import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-6" }
const _hoisted_2 = { class: "s7" }
const _hoisted_3 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_4 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_5 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_6 = { class: "s7" }
const _hoisted_7 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_8 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_9 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_10 = { class: "s6" }
const _hoisted_11 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_12 = { class: "s10" }
const _hoisted_13 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_14 = {
  class: "secondary-font font-semibold text-grey-900 py-1",
  style: {"white-space":"nowrap"}
}
const _hoisted_15 = { class: "secondary-font font-semibold text-purple" }
const _hoisted_16 = { class: "s10 text-right" }
const _hoisted_17 = {
  key: 0,
  class: "secondary-font font-semibold text-primary-color pb-1"
}
const _hoisted_18 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_19 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_20 = {
  key: 3,
  class: "secondary-font font-semibold text-grey-600 pt-1"
}
const _hoisted_21 = {
  key: 4,
  class: "secondary-font font-semibold text-grey-600 py-1"
}

import { onMounted, ref } from 'vue';
import { formatAmount } from '@/utils';
import axios from 'axios';
import moment from 'moment';
import CustomWidget from '@/components/CustomWidget.vue';

interface DecaissementMensuel {
    id: number;
    mois: number;
    date_prevision: string | null;
    date_operation: string | null;
    montant: number;
    percent: number;
    statut: 'pending' | 'done' | 'cancelled';
    countdown: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDecaissementsMensuels',
  props: {
    userId: {}
  },
  setup(__props: any) {

// @ts-expect-error raison: lib externe mal typée
const props = __props;
const decaissementsMensuels = ref<DecaissementMensuel[]>([]);
const decaissementsStats = ref({
    debloque: 0,
    debloque_percent: 0,
    bloque: 0,
    bloque_percent: 0,
    total: 0,
});
const decaissementsLoading = ref(false);
const minimized = ref(true);

onMounted(() => {
    loadDecaissementsMensuels();
});

async function loadDecaissementsMensuels() {
    decaissementsLoading.value = true;
    try {
        const response = await axios.get(`/backoffice/users/${props.userId}/decaissements_mensuels`);
        decaissementsMensuels.value = response.data.items || [];
        decaissementsStats.value = response.data.stats || {
            debloque: 0, debloque_percent: 0,
            bloque: 0, bloque_percent: 0,
            total: 0,
        };
    } catch (error: any) {
        console.error('Erreur chargement décaissements mensuels:', error);
    } finally {
        decaissementsLoading.value = false;
    }
}

function formatPrelevementDateLong(dateString: string | null): string {
    if (!dateString) return '-';
    const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    const date = moment(dateString);
    if (!date.isValid()) return '-';
    return `${date.format('DD')} ${monthsFr[date.month()]} ${date.year()}`;
}

function formatPrelevementDate(dateString: string | null): string {
    if (!dateString) return '-';
    const monthsFr = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];
    const date = moment(dateString);
    if (!date.isValid()) return '-';
    return `${date.format('DD')} ${monthsFr[date.month()]} ${date.year()}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomWidget, {
    title: "Décaissement mensuel",
    items: decaissementsMensuels.value,
    loading: decaissementsLoading.value
  }, {
    action: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("button", { class: "btn lg py-3 white2 active" }, [
        _createElementVNode("img", {
          src: "/icons/icon-consulter.svg",
          class: "btn-icon",
          alt: ""
        }),
        _createElementVNode("span", null, "Revolving")
      ], -1)
    ]))]),
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
            _createTextVNode(" Débloqué ")
          ], -1)),
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(formatAmount)(decaissementsStats.value.debloque)) + " F", 1),
          _createElementVNode("h5", _hoisted_4, _toDisplayString(decaissementsStats.value.debloque_percent) + "%", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
              style: _normalizeStyle(`width: ${decaissementsStats.value.debloque_percent}%;`)
            }, _toDisplayString(decaissementsStats.value.debloque_percent) + "% ", 5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-purple" }),
            _createTextVNode(" Bloqué ")
          ], -1)),
          _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(formatAmount)(decaissementsStats.value.bloque)) + " F", 1),
          _createElementVNode("h5", _hoisted_8, _toDisplayString(decaissementsStats.value.bloque_percent) + "%", 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
              style: _normalizeStyle(`width: ${decaissementsStats.value.bloque_percent}%;`)
            }, _toDisplayString(decaissementsStats.value.bloque_percent) + "% ", 5)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-green-light" }),
            _createTextVNode(" Total ")
          ], -1)),
          _createElementVNode("h1", _hoisted_11, _toDisplayString(_unref(formatAmount)(decaissementsStats.value.total)) + " F", 1),
          _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "h-40 rounded-100 position-relative overflow-hidden",
            style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
          }, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
              style: {"width":"100%"}
            }, " 100% ")
          ], -1))
        ])
      ])
    ]),
    item: _withCtx(({ item }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5", { active: item.statut === 'done', 'opacity-6': item.statut === 'cancelled' }])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h6", _hoisted_13, _toDisplayString(formatPrelevementDateLong(item.date_prevision)), 1),
          _createElementVNode("h3", _hoisted_14, _toDisplayString(_unref(formatAmount)(item.montant)) + " F", 1),
          _createElementVNode("p", _hoisted_15, _toDisplayString(item.percent) + "%", 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          (item.statut === 'pending' && item.countdown)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_17, _toDisplayString(item.countdown), 1))
            : _createCommentVNode("", true),
          (item.statut === 'done')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
              ]))]))
            : (item.statut === 'cancelled')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "tag-state danger stroke" }, "Annulé", -1)
                ]))]))
              : _createCommentVNode("", true),
          (item.statut === 'done' && item.date_operation)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, "Date de déblocage"))
            : _createCommentVNode("", true),
          (item.statut === 'done' && item.date_operation)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_21, _toDisplayString(formatPrelevementDate(item.date_operation)), 1))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["items", "loading"]))
}
}

})